import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui-compat"
import { styled } from "@mui/system"
import SessionNoStage from "components/sessions/SessionNoStage"
import SessionStage from "components/sessions/SessionStage"
import useCurrent from "lib/use-current"
import Convention from "models/convention-api/v1/Convention"
import ConventionExhibitor from "models/convention-api/v1/ConventionExhibitor"
import ConventionSession from "models/convention-api/v1/ConventionSession"

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      background: theme.palette.primary.main,
    },
    header: {
      fontFamily: "Raleway",
      color: "white",
      fontSize: "36px",
      padding: "20px 20px 0 20px",
      [theme.breakpoints.up("md")]: {
        padding: "40px 40px 20px 40px",
        borderRadius: "0",
      },
    },
  })
)

interface StageHeroProps {
  convention: Convention
  session?: ConventionSession
  conventionExhibitor: ConventionExhibitor
}

const StageHero = (props: StageHeroProps) => {
  const { convention, session, conventionExhibitor } = props

  const { classes } = useStyles()
  const current = useCurrent()

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Box display="flex" alignItems="center">
          {/*// @ts-ignore*/}
          {current.config.nav_stage_copy_text}
        </Box>

        <p style={{ fontSize: "16px" }}>
          <span style={{ fontStyle: "italic", marginRight: "4px" }}>by </span>
          {conventionExhibitor.exhibitor_name}
        </p>
      </div>
      {session ? (
        <_SessionStage session={session} />
      ) : (
        <_SessionNoStage imageSrc={convention.hero_image_url} />
      )}
    </div>
  )
}

export default StageHero

const _SessionNoStage = styled(SessionNoStage)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    borderRadius: "0",
  },

  // BlurredBackground
  "& > div": {
    width: "100%",
  },
  "& > div > *": {
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
  },
})) as typeof SessionNoStage

const _SessionStage = styled(SessionStage)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    borderRadius: "0",
  },

  // BlurredBackground
  "& > div": {
    width: "100%",
  },
  "& > div > *": {
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
  },
})) as typeof SessionStage
